<template>
  <div id="app">
    <mainLoading />
    <mainNotifications v-if="$store.state.utils.notificationBox.length > 0" />
    <!-- <mainPopups v-if="$store.state.utils.cookies" /> -->
    <router-view />
  </div>
</template>

<script>
import mainLoading from "./components/Loading.vue";
import mainPopups from "./components/Popups.vue";
import mainNotifications from "./components/Notifications.vue";

export default {
  name: "App",
  metaInfo() {
    let lang = "en-US";
    let dir = "ltr";

    if (!localStorage.details || localStorage.details == undefined) {
      this.$store.state.utils.cookies = true;
    } else {
      this.$store.state.utils.cookies = false;
    }

    let language = undefined;
    if (localStorage.language) {
      language = localStorage.language;
    } else {
      this.$store.state.utils.switchLanguage("en");
    }

    switch (language) {
      case "en":
      case "de":
        lang = "en-US";
        dir = "ltr";
        break;
      case "ar":
        lang = "ar-SY";
        dir = "rtl";
        document.querySelector("body").classList.toggle("rtl");
        break;
    }

    return {
      htmlAttrs: {
        lang: lang,
        dir: dir,
      },
    };
  },

  components: {
    mainLoading,
    mainPopups,
    mainNotifications,
  },

  data() {
    return { vue_viewer: null };
  },

  mounted() {
    this.$nextTick(() => {
      !this.$route.name ? this.$router.push({ name: "LandingPage" }) : true;
    });
  },

  methods: {},

  destroyed() {},
};
</script>

